var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damage-part-content" }, [
    _c(
      "div",
      {
        staticClass: "damage-part",
        class: [{ buttonDeleteIsVisible: _vm.showDeleteBtn }],
      },
      [
        _c("p", { staticClass: "name-part" }, [
          _vm._v(_vm._s(_vm.damagedPart.literal)),
        ]),
        _c("svgicon", {
          staticClass: "icon-part",
          attrs: {
            name: "more-vertical",
            color: "#566473",
            width: "24",
            height: "24",
          },
          on: { click: _vm.handleMoreOptions },
        }),
        _c(
          "div",
          { staticClass: "buttonDelete", attrs: { "v-if": _vm.showDeleteBtn } },
          [
            _c(
              "div",
              {
                staticClass: "containerBtn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("deleteDamagedPart")
                  },
                },
              },
              [
                _c("svgicon", {
                  staticClass: "icon",
                  attrs: {
                    name: "ico-delete",
                    color: "#EF4136",
                    height: "13",
                    width: "15",
                  },
                }),
                _c("p", { staticClass: "text-medium redVidid" }, [
                  _vm._v(_vm._s(_vm.$t("multidamageList.delete"))),
                ]),
              ],
              1
            ),
          ]
        ),
        _vm._l(_vm.damagedPart.partDamages, function (damage, i) {
          return _vm.damagedPart.partDamages != null
            ? _c(
                "ul",
                { key: i },
                [
                  _c("maDamageItem", {
                    attrs: { damage: damage },
                    on: {
                      editDamage: function ($event) {
                        return _vm.$emit("editDamage", i)
                      },
                      deleteDamage: function ($event) {
                        return _vm.$emit("deleteDamage", i)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e()
        }),
        _c("div", { staticClass: "container-btn-add-element" }, [
          _c(
            "button",
            {
              staticClass: "btn",
              attrs: { disabled: !_vm.buttonEnable },
              on: { click: _vm.handleOnShowModal },
            },
            [
              _c("svgicon", {
                attrs: {
                  name: "plus",
                  color: "$primary01",
                  height: "15",
                  width: "auto",
                },
              }),
              _c("p", { staticClass: "text-medium" }, [
                _vm._v(_vm._s(_vm.$t("multidamageList.btnAddDamage"))),
              ]),
            ],
            1
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }